import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleCards() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <p className="text-xs font-semibold uppercase tracking-widest text-secondary-600 mb-2 whitespace-nowrap">/ Learn &amp; Explore</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Latest Guides &amp; <span className="text-primary-500">Resources</span>
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-md">
            In-depth articles and tutorials to help you get the most out of the AcBuy Spreadsheet. New content added regularly.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/guide${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-[400ms]"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium whitespace-nowrap">{article.tag}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-4">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-primary-500 text-sm font-semibold whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}